<p *ngFor="let code of validators " [attr.code]="code">
  {{messages[code] ? messages[code] : defaultErrorMessages[code]}}
</p>
